import React, {ChangeEvent, FC} from "react";
import {AdditionalServiceDto} from "../../types/contracts";
import {EventConfigurationModal} from "../EventConfigurationModal";
import {MdOutlineDelete} from "react-icons/md";
import {useScrollRef} from "../../hooks/useScrollRef";
import {IoAddCircleOutline} from "react-icons/io5";

type Props = {
    open: boolean;
    onClose: () => void;
    services: AdditionalServiceDto[];
    handleServiceChange: (
        index: number,
        e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>
    ) => void;
    handleCheckboxChange: (index: number) => void;
    removeService: (index: number) => void;
    addService: () => void;
}

export const ServiceComponentModal:FC<Props> = ({open, onClose, services, handleServiceChange, handleCheckboxChange, removeService, addService}) => {
    const {contentRef, handleScroll, lastItemRef} = useScrollRef(services.length);

    const handleAddService = () => {
        addService();
        handleScroll();
    };

    return (
        <EventConfigurationModal open={open} onClose={onClose} title="Doplňkové služby" confirmText="Přidat" onConfirm={handleAddService} contentRef={contentRef}>
            {services.length === 0 && (
                <div className="flex items-center justify-center gap-2 p-4 border border-gray-200 rounded-md cursor-pointer" onClick={handleAddService}>
                    <IoAddCircleOutline />
                    <p>Přidejte první službu</p>
                </div>
            )}
            {services.map((service, index) => (
                <div
                    key={index}
                    className="mb-4 p-4 border border-gray-200 rounded-md min-w-[300px]"
                    ref={index === services.length - 1 ? lastItemRef : null}
                >
                    <div className="mb-2 flex items-start justify-between">
                        <label
                            className="block mb-2 font-semibold"
                            htmlFor={`service-name-${index}`}
                        >
                            Název
                        </label>
                        <button
                            type="button"
                            onClick={() => removeService(index)}
                            className="text-red-600 hover:text-red-800"
                            title="Odstranit ubytování"
                        >
                            <MdOutlineDelete size={20}/>
                        </button>
                    </div>
                    <textarea
                        id={`service-name-${index}`}
                        name="name"
                        value={service.name}
                        onChange={(e) => handleServiceChange(index, e)}
                        className="w-full p-2 border border-gray-300 rounded-md"
                        required
                    />
                    <div className="mb-4">
                        <label
                            className="block mb-2 font-semibold"
                            htmlFor={`service-price-${index}`}
                        >
                            Cena
                        </label>
                        <input
                            type="number"
                            id={`service-price-${index}`}
                            name="amount"
                            value={service.amount}
                            onChange={(e) => handleServiceChange(index, e)}
                            className="w-full p-2 border border-gray-300 rounded-md"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label
                            className="block mb-2 font-semibold"
                            htmlFor={`service-description-${index}`}
                        >
                            Popisek
                        </label>
                        <textarea
                            id={`service-description-${index}`}
                            name="description"
                            value={service.description}
                            onChange={(e) => handleServiceChange(index, e)}
                            className="w-full p-2 border border-gray-300 rounded-md"
                        />
                    </div>
                    <div className="mb-4 flex items-center">
                        <input
                            type="checkbox"
                            id={`service-forWholeEvent-${index}`}
                            checked={service.forWholeEvent}
                            onChange={() => handleCheckboxChange(index)}
                            className="mr-2"
                        />
                        <label
                            htmlFor={`service-forWholeEvent-${index}`}
                            className="font-semibold"
                        >
                            Po celou dobu události
                        </label>
                    </div>
                    {!service.forWholeEvent && (
                        <div className="mb-4">
                            <label
                                className="block mb-2 font-semibold"
                                htmlFor={`service-date-${index}`}
                            >
                                Datum
                            </label>
                            <input
                                type="date"
                                id={`service-date-${index}`}
                                name="date"
                                value={service.date || ""}
                                onChange={(e) => handleServiceChange(index, e)}
                                className="w-full p-2 border border-gray-300 rounded-md"
                            />
                        </div>
                    )}
                    <div className="flex items-center gap-2 mt-2">
                        <input
                            type="checkbox"
                            id={`service-isHiddenInRegistration-${index}`}
                            name="isHiddenInRegistration"
                            checked={service.isHiddenInRegistration}
                            onChange={(e) => handleServiceChange(index, e)}
                            className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                        />
                        <label
                            htmlFor={`service-isHiddenInRegistration-${index}`}
                            className="text-sm"
                        >
                            Skrýt ve formuláři (nedostupné)
                        </label>
                    </div>
                </div>
            ))}
        </EventConfigurationModal>
    );
};